import { j as e } from "../../jsx-runtime.BREq8dyb.js";
import { testIds as et } from "@decentriq/utils";
import { cx as P } from "@emotion/css";
import { faAngleRight as ot, faXmark as nt, faBug as v, faTriangleExclamation as st, faCircleExclamation as y, faCloudSlash as it, faCopy as rt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as l } from "@fortawesome/react-fontawesome";
import { styled as s, Sheet as at, Box as x, IconButton as lt, useThemeProps as dt } from "@mui/joy";
import { useSnackbar as ct, SnackbarContent as pt } from "notistack";
import { memo as h, forwardRef as T, useState as xt, useEffect as ft } from "react";
import mt from "../../transitions/Collapse/Collapse.js";
const ut = {
  bug: "danger",
  copied: void 0,
  default: void 0,
  error: "danger",
  info: void 0,
  network: void 0,
  success: "success",
  warning: "warning"
}, gt = {
  bug: /* @__PURE__ */ e.jsx(l, { fixedWidth: !0, icon: v }),
  copied: /* @__PURE__ */ e.jsx(l, { fixedWidth: !0, icon: rt }),
  default: /* @__PURE__ */ e.jsx(l, { fixedWidth: !0, icon: y }),
  error: /* @__PURE__ */ e.jsx(l, { fixedWidth: !0, icon: y }),
  info: /* @__PURE__ */ e.jsx(l, { fixedWidth: !0, icon: y }),
  network: /* @__PURE__ */ e.jsx(l, { fixedWidth: !0, icon: it }),
  success: /* @__PURE__ */ e.jsx(l, { fixedWidth: !0, icon: y }),
  warning: /* @__PURE__ */ e.jsx(l, { fixedWidth: !0, icon: st })
}, E = {
  expanded: "Mui-expanded"
  // NOTE: Chose this name to mimic the behaviour of Joy components
}, i = "DqAlert", ht = s(at, {
  name: i,
  slot: "root"
})(({
  theme: t,
  ownerState: {
    color: o,
    variant: n
  }
}) => ({
  alignItems: "stretch",
  borderRadius: t.radius.sm,
  display: "flex",
  fontSize: "0.875rem",
  lineHeight: "1.25rem",
  width: "100%",
  ...!o && !n && {
    backgroundColor: t.palette.common.black,
    color: t.palette.common.white
  }
  /**
   * TODO:
   * 1. Add support for the `size` prop once proper global scaling system is defined and in place.
   * 2. Adjust paddings if `variant` is "outlined" (i.e. 1px less than the regular padding).
   * 3. Mimic the baseline adjustments that were added to the default `Alert` component.
   */
})), bt = s(x, {
  name: i,
  slot: "icon"
})(({
  theme: t
}) => ({
  fontSize: "1rem",
  paddingLeft: t.spacing(1),
  paddingTop: t.spacing(0.75)
})), jt = s(x, {
  name: i,
  slot: "content"
})({
  display: "flex",
  flex: 1,
  flexWrap: "wrap",
  overflow: "hidden"
}), St = s(x, {
  name: i,
  slot: "subject"
})({
  display: "flex",
  flex: "1 1 auto",
  flexWrap: "nowrap",
  justifyContent: "space-between"
}), wt = s(x, {
  name: i,
  slot: "message"
})(({
  theme: t
}) => ({
  alignItems: "flex-start",
  display: "flex",
  flex: 1,
  padding: t.spacing(0.75, 1)
})), Wt = s(x, {
  name: i,
  slot: "expand"
})(({
  theme: t
}) => ({
  alignItems: "flex-start",
  display: "flex",
  padding: t.spacing(0.5)
})), Ct = s(mt, {
  name: i,
  slot: "context"
})(({
  theme: t,
  ownerState: {
    color: o,
    variant: n
  }
}) => ({
  borderBottomWidth: 0,
  borderColor: n ? t.palette[o || "neutral"][`${n}HoverBg`] : "rgba(255, 255, 255, 0.2)",
  borderLeftWidth: 0,
  borderRightWidth: 0,
  borderStyle: "solid",
  borderTopWidth: 0,
  flex: "1 1 auto",
  maxHeight: "400px",
  overflow: "auto !important",
  // NOTE: Overriding `overflow: "visible"` set by `Collapse`
  padding: t.spacing(0, 1, 0.75),
  width: "100%"
})), yt = s(x, {
  name: i,
  slot: "action"
})(({
  theme: t,
  ownerState: {
    color: o,
    variant: n
  }
}) => ({
  alignItems: "flex-start",
  borderBottomWidth: 0,
  borderColor: n ? t.palette[o || "neutral"][`${n}HoverBg`] : "rgba(255, 255, 255, 0.2)",
  borderLeftWidth: "1px",
  borderRightWidth: 0,
  borderStyle: "solid",
  borderTopWidth: 0,
  display: "flex",
  padding: t.spacing(0.5)
})), Dt = s(x, {
  name: i,
  slot: "dismiss"
})(({
  theme: t,
  ownerState: {
    color: o,
    variant: n
  }
}) => ({
  alignItems: "flex-start",
  borderBottomWidth: 0,
  borderColor: n ? t.palette[o || "neutral"][`${n}HoverBg`] : "rgba(255, 255, 255, 0.2)",
  borderLeftWidth: "1px",
  borderRightWidth: 0,
  borderStyle: "solid",
  borderTopWidth: 0,
  display: "flex",
  padding: t.spacing(0.5)
})), z = h(({
  IconProps: t,
  ...o
}) => /* @__PURE__ */ e.jsx(lt, { ...o, children: /* @__PURE__ */ e.jsx(l, { fixedWidth: !0, ...t }) }));
z.displayName = "DqAlertIconButton";
const L = s(z, {
  name: i,
  slot: "expandButton"
})(({
  theme: t,
  variant: o
}) => ({
  "& > svg": {
    transition: "0.2s"
  },
  [`&.${E.expanded} > svg`]: {
    transform: "rotate(90deg)"
  },
  borderRadius: `calc(${t.radius.sm} - ${t.spacing(0.5)})`,
  fontSize: "1rem",
  // NOTE: Remove this (and adjust `padding`) after `--Icon-fontSize` is bound to FontAwesomeIcon
  minHeight: 0,
  minWidth: 0,
  padding: t.spacing(o === "outlined" ? 0.375 : 0.5)
}));
L.displayName = "DqAlertExpandIconButton";
const M = s(z, {
  name: i,
  slot: "dismissButton"
})(({
  theme: t,
  variant: o
}) => ({
  borderRadius: `calc(${t.radius.sm} - ${t.spacing(0.5)})`,
  fontSize: "1rem",
  // NOTE: Remove this (and adjust `padding`) after `--Icon-fontSize` is bound to FontAwesomeIcon
  minHeight: 0,
  minWidth: 0,
  padding: t.spacing(o === "outlined" ? 0.375 : 0.5)
}));
M.displayName = "DqAlertDismissIconButton";
const b = h(T((t, o) => {
  const n = dt({
    name: i,
    props: t
  }), {
    className: f,
    ...m
  } = n, {
    icon: u,
    color: c,
    variant: D = "solid",
    message: p = "Something happened",
    context: j,
    expand: A,
    action: S,
    dismiss: I,
    showDismiss: k = !1,
    showExpand: B = !1,
    isExpanded: a = !1,
    onExpand: w = () => {
    },
    onDismiss: W = () => {
    },
    slotProps: q
  } = n, {
    root: N,
    icon: X,
    content: G,
    subject: J,
    message: K,
    expand: Q,
    expandButton: U,
    context: Y,
    action: Z,
    dismiss: _,
    dismissButton: V
  } = q || {}, [C, H] = xt(a), r = {
    ...m,
    isExpanded: C
  }, R = B ? A || /* @__PURE__ */ e.jsx(L, { IconProps: {
    icon: ot
  }, className: P({
    [E.expanded]: C
  }), color: c, onClick: (g) => {
    g.stopPropagation(), H((tt) => !tt), typeof w == "function" && w(g);
  }, ownerState: r, ...U }) : null, $ = k ? I || /* @__PURE__ */ e.jsx(M, { IconProps: {
    icon: nt
  }, color: c, onClick: (g) => {
    g.stopPropagation(), typeof W == "function" && W(g);
  }, ownerState: r, ...V }) : null;
  return ft(() => {
    H(a);
  }, [a]), /* @__PURE__ */ e.jsxs(ht, { className: P(f, {
    [E.expanded]: C
  }), color: c, invertedColors: !0, ownerState: r, ref: o, variant: D, ...N, children: [
    u ? /* @__PURE__ */ e.jsx(bt, { children: u, className: "icon", ownerState: r, ...X }) : null,
    /* @__PURE__ */ e.jsxs(jt, { className: "content", ownerState: r, ...G, children: [
      /* @__PURE__ */ e.jsxs(St, { className: "subject", ownerState: r, ...J, children: [
        p ? /* @__PURE__ */ e.jsx(wt, { children: p, className: "message", ownerState: r, ...K }) : null,
        R ? /* @__PURE__ */ e.jsx(Wt, { children: R, className: "expand", ownerState: r, ...Q }) : null
      ] }),
      j ? /* @__PURE__ */ e.jsx(Ct, { children: j, className: "context", in: C, ownerState: r, timeout: 0, unmountOnExit: !0, ...Y }) : null
    ] }),
    S ? /* @__PURE__ */ e.jsx(yt, { children: S, className: "action", ownerState: r, ...Z }) : null,
    $ ? /* @__PURE__ */ e.jsx(Dt, { children: $, className: "dismiss", ownerState: r, ..._ }) : null
  ] });
}));
b.displayName = "DqAlert";
const F = T(({
  action: t,
  className: o,
  context: n,
  dismiss: f,
  expand: m,
  onDismiss: u,
  onExpand: c,
  hideIconVariant: D = !1,
  iconVariant: p,
  id: j,
  message: A,
  showDismiss: S = !1,
  showExpand: I = !1,
  isExpanded: k = !1,
  style: B,
  variant: a,
  // NOTE: Snackbar's `variant` is converted to `color` (the alert itself is currently always "solid")
  slotProps: w,
  persist: W
}, q) => {
  const {
    closeSnackbar: N
  } = ct();
  return /* @__PURE__ */ e.jsx(pt, { className: P(o, [a]), "data-testid": `${et.components.alert.alertHelper}${a}`, ref: q, role: "alert", style: B, children: /* @__PURE__ */ e.jsx(
    b,
    {
      action: t,
      color: a && ut[a] || void 0,
      context: n,
      dismiss: f,
      expand: m,
      icon: D ? null : a && p && p[a] || p && p.default || null,
      isExpanded: k,
      message: A,
      onDismiss: u || (() => N(j)),
      onExpand: c,
      showDismiss: S || W,
      showExpand: I || !!n,
      slotProps: w
    }
  ) });
});
F.displayName = "WithinSnackbarContent";
const d = h(s(F)(({
  theme: t
}) => ({
  alignItems: "stretch",
  borderRadius: t.radius.sm,
  /**
   * NOTE: Previous `boxShadow` was "rgb(9 30 66 / 31%) 0px 0px 1px 0px, rgb(9 30 66 / 25%) 0px 20px 32px -8px",
   * current shadow should probably be `theme.shadow.sm`, but the whole UI is flat, hence removing it for now.
   */
  display: "flex",
  fontSize: "0.875rem",
  lineHeight: "1.25rem"
})));
d.displayName = "StyledWithinSnackbarContent";
const At = h(s(b)({
  "& > *, & > .icon > *, & > .content > *, & > .content > .subject > *, & > .content > .subject > .message > *, & > .content > .subject > .expand > *, & > .content > .context > *, & > .action > *, & > .dismiss > *": {
    position: "relative"
  },
  "& > *:after, & > .icon > *:after, & > .content > *:after, & > .content > .subject > *:after": {
    border: "1px dashed violet",
    zIndex: 1
  },
  "& > *:after, & > .icon > *:after, & > .content > *:after, & > .content > .subject > *:after, & > .content > .subject > .message > *:after, & > .content > .subject > .expand > *:after, & > .content > .context > *:after, & > .action > *:after, & > .dismiss > *:after": {
    bottom: 0,
    content: '""',
    height: "100%",
    left: 0,
    position: "absolute",
    right: 0,
    top: 0,
    width: "100%"
  },
  "& > .content > .subject > .expand > *:after, & > .action > *:after, & > .dismiss > *:after": {
    border: "1px dashed skyblue",
    zIndex: 2
  },
  "& > .content > .subject > .message > *:after, & > .content > .context > *:after": {
    border: "1px dashed lightgreen",
    zIndex: 2
  },
  "& > .icon:before": {
    border: "1px dashed lightgreen",
    content: '""',
    height: 20,
    left: 8,
    position: "absolute",
    top: 6,
    width: 16,
    zIndex: 2
  }
})), O = h(({
  error: t = {},
  resetErrorBoundary: o,
  ...n
}) => {
  let f, m;
  if (t instanceof Error) {
    ({
      name: f
    } = t);
    const {
      message: u,
      stack: c
    } = t;
    m = /* @__PURE__ */ e.jsxs("span", { children: [
      u,
      /* @__PURE__ */ e.jsx("br", {}),
      /* @__PURE__ */ e.jsx("code", { style: {
        fontSize: "0.75rem",
        lineHeight: 1.5,
        margin: 0,
        maxHeight: "50vh",
        maxWidth: "50vw",
        overflow: "auto",
        whiteSpace: "pre-wrap"
      }, children: c })
    ] });
  }
  return /* @__PURE__ */ e.jsx(b, { color: "danger", icon: /* @__PURE__ */ e.jsx(l, { fixedWidth: !0, icon: v }), ...n, context: m, message: f, onDismiss: o });
});
O.displayName = "AsFallbackComponent";
const Rt = Object.assign(b, {
  AsFallbackComponent: O,
  WithinSnackbarContent: d,
  Xray: At
}), $t = {
  horizontal: "center",
  vertical: "bottom"
}, vt = {
  bug: d,
  copied: d,
  default: d,
  error: d,
  info: d,
  network: d,
  success: d,
  warning: d
}, Tt = gt;
export {
  Rt as default,
  $t as defaultSnackbarAnchorOrigin,
  vt as defaultSnackbarComponents,
  Tt as defaultSnackbarIconVariant,
  E as dqAlertClasses
};
//# sourceMappingURL=DqAlert.js.map
